import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../../styles/designSystem';
import PropTypes from 'prop-types';

export const GradientButton = forwardRef(({ children, variant = 'primary', to, ...props }, ref) => {
  const gradientClass =
    variant === 'success' ? colors.success.gradient : colors.primary.gradient;

  // If 'to' prop is provided, render as Link
  if (to) {
    return (
      <Link
        ref={ref}
        to={to}
        className={`inline-block px-8 py-3 rounded-xl ${gradientClass} text-white shadow-lg hover:shadow-xl transition-all duration-200`}
        {...props}
      >
        {children}
      </Link>
    );
  }

  // Otherwise, render as button
  return (
    <button
      ref={ref}
      className={`px-8 py-3 rounded-xl ${gradientClass} text-white shadow-lg hover:shadow-xl transition-all duration-200`}
      {...props}
    >
      {children}
    </button>
  );
});

// Add a display name for better debugging
GradientButton.displayName = 'GradientButton';

// Define PropTypes for better type checking
GradientButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'success']),
  to: PropTypes.string, // 'to' prop is optional
};
